import { Theme } from "@mui/material";

export const Variants = (theme: Theme) => {
  return {
    ticket: {
      padding: `${theme.space._400} ${theme.space._600} ${theme.space._500} ${theme.space._600}`,
      maxWidth: "24rem",
      borderRadius: theme.space._400,

      background: theme.colors["neutral.900"],

      "&::before, ::after": {
        content: '""',
        position: "absolute",
        backgroundColor: "black",
        width: "1.5rem",
        height: "3.5rem",
        zIndex: 1,
      },
      "&::before" : {
        left: 0,
        borderRadius: "0 1.5rem 1.5rem 0",
      },
      "&::after" : {
        right: 0,
        borderRadius: "1.5rem 0 0 1.5rem",
      },
    },
    unstyled: {
      flexShrink: 0
    }
  }
}